export class Unauthorized {
    constructor(public authUri: string) {
    }
}